import { HiPlus } from 'react-icons/hi';
import { Button } from 'flowbite-react';
import { isEmpty } from 'lodash';
import { searchMaxLength } from 'utils/constants';

import './actionTable.scss';

const ActionTable = (props: any) => {
  const { placeholderSearch, buttonName, handleAddClick, handleSearch, hiddenSearch } = props;

  const handleoOnKeyUp = (e: any) => {
    const { key, target } = e;
    if (key === 'Enter') handleSearch(target.value);
  };

  const handleoOnChange = (e: any) => {
    if (isEmpty(e.target.value)) handleSearch(e.target.value);
  };

  return (
    <>
      <div className="flex py-5 justify-end mr-5 action-table">
        {!hiddenSearch && (
          <input
            className="w-72 border-1 border-gray-300 bg-white h-9 rounded-lg text-sm focus:outline-none mr-5 action-search"
            type="search"
            name="search"
            maxLength={searchMaxLength}
            placeholder={placeholderSearch}
            onChange={e => handleoOnChange(e)}
            onKeyUp={e => handleoOnKeyUp(e)}
          />
        )}

        <div>
          {handleAddClick && (
            <div className="flex w-full w-auto flex-row gap-2 action-add">
              <Button size="sm" className="" onClick={() => handleAddClick()}>
                <HiPlus className="mr-1 h-4 w-4" />
                {buttonName}
              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default ActionTable;
